import { useMemo } from "react";
import { useAuthContext } from "providers/Auth";
import { useLeadSources } from "views/settings-crm/slices/lead-sources/api";
import { ContactFormsSubmenuLeadSource } from "./types";

export const useEligibleContactFormSources = ({
  enabled = true
}: { enabled?: boolean } = {}) => {
  // Per-source links mint tenant leads, so without tenant_leads there is nothing
  // to offer: every "Contact form" action on properties / units hides (CRM-759).
  const { type } = useAuthContext();
  const leadsEnabled = type.isTenantLeads;
  const { data, isLoading } = useLeadSources({
    // Lead sources are near-static; without a staleTime the closed popover unmounts its
    // observer and every menu open refetches the whole list.
    staleTime: 5 * 60_000,
    // Callers on pages that render for non-CRM partners pass enabled: false so those
    // partners don't pay for a list they can never see.
    enabled: enabled && leadsEnabled
  });

  const eligibleSources = useMemo<ContactFormsSubmenuLeadSource[]>(
    () =>
      (leadsEnabled ? (data?.items ?? []) : [])
        .filter((source) => source.enable_contact_form)
        .map((source) => ({
          id: source.id,
          name: source.name,
          color: source.color
        })),
    [data, leadsEnabled]
  );

  return { eligibleSources, isLoading };
};
